import OpenAI from 'openai';

let openaiInstance: OpenAI | null = null;

export const initOpenAI = (apiKey: string) => {
  if (!apiKey) {
    throw new Error('Missing OpenAI API key');
  }

  openaiInstance = new OpenAI({
    apiKey,
    dangerouslyAllowBrowser: true // For client-side use (consider moving to server-side in production)
  });

  return openaiInstance;
};

export const getOpenAI = (): OpenAI => {
  if (!openaiInstance) {
    throw new Error('OpenAI not initialized. Call initOpenAI first.');
  }
  return openaiInstance;
};

// Mantener export para compatibilidad (será un getter)
export const openai = new Proxy({} as OpenAI, {
  get: (_target, prop) => {
    const instance = getOpenAI();
    return (instance as any)[prop];
  }
});

export const OPENAI_MODEL = 'gpt-4-turbo-preview';


